import qs from "qs";
import { useLanguageStore } from "~/store/languageStore";

export const getFaqCategoriesQuery = () => {
  return qs.stringify({
    locale: useLanguageStore().language.name,
    fields: ["title", "slug", "metaTitle", "metaDescription"],
    filters: {
      questions: {
        id: {
          $notNull: true,
        },
      },
    },
    sort: "position:asc",
  });
};
export const getFaqQuestionsQuery = (filters) => {
  return qs.stringify({
    locale: useLanguageStore().language.name,
    fields: ["question", "answer"],
    filters,
    sort: "position:asc",
  });
};
